
    var riot = require('riot')
    
riot.tag2('pricetag', '<button if="{!opts.showqty}" type="button" onclick="{handleBuyClick}" class="btn {opts.btnClass || \'btn-primary\'}">Buy</button>', 'pricetag{ display:block; margin:5px 0; } pricetag .price_title{ grid-area:title; } pricetag .price_ref{ grid-area:ref; } pricetag .price_member{ grid-area:price; text-align:right; } pricetag .price_rrp{ grid-area:rrp; text-align:right; } pricetag button{ grid-area:buy; }', '', function(opts) {
var basketResource, resource, tagSelector;

resource = require('riot-kit/utils/apiResource.coffee');

tagSelector = require('riot-kit/utils/tagSelector.coffee');

basketResource = new resource(opts.src || '/duocms/api/basket');

this.on('mount', (function(_this) {
  return function() {
    _this.basket = tagSelector('basket', 'popup-basket');
    return _this.update();
  };
})(this));

this.handleBuyClick = (function(_this) {
  return function() {
    var qty, ref;
    qty = (ref = _this.quantity) != null ? ref.value : void 0;
    return basketResource.post({
      id: opts.productid,
      qty: qty
    }, function() {
      if (window["addToGoogle" + opts.productid]) {
        window["addToGoogle" + opts.productid](qty);
      }
      if (_this.basket) {
        return _this.basket.trigger('updateBasket');
      }
    });
  };
})(this);
});
    
  